import styled from 'styled-components';
export default styled.div.withConfig({
  displayName: "WidthConstrainer",
  componentId: "sc-15doeus-0"
})(["\n  ", ";\n"], function (_ref) {
  var shouldFitContainer = _ref.shouldFitContainer;
  return shouldFitContainer ? '' : 'max-width: 300px;';
});